import { DataSpec, GET_BY_ID, ServerDataProvider } from "../../data/server_data_provider";

import * as GALLERIES from "galleries";
import { NON_EXISTING } from "../../data/data_provider";

export let dataSpec: DataSpec;
if (BUILD_PLATFORM === "node" || DEV_MODE) {
  dataSpec = {
    gallery: {
      async [GET_BY_ID](ids: string[]) {
        const gallery = GALLERIES.getGallery(ids[0]);
        if (!gallery) return NON_EXISTING;
        return gallery;
      },
    },
  };
}
